import './debugger'
import ready from './ready'
import invoke from './invoke'
import { publish } from './publish';

interface HXJSBridge {
  invoke(data: object): void
  publish(action: string, data: object, reqId: number): void
  ready(): void
}

declare global {
  interface Window {
    Workspace: any
    Bindings: any
    HXJSBridge: HXJSBridge
    __postMessageToHBuilderX__(data: string): void
  }
}

window.HXJSBridge = {
  ready,
  invoke,
  publish
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/bridge/index.ts